<template>
  <div class="rate-amount">
    <rate-points v-if="amount_points" :amount_points="amount_points" :rate_only="rate_only"/>
    <rate-pricing v-else :pricing="pricing" :rate_only="rate_only"/>
  </div>
</template>

<script>
import { markupPricing, compute_amount_points } from '@liveeps/utilities/utilities'
import { get_to_points } from '@utilities/commons'
import RatePoints from "@liveeps/components/atoms/rate-points"
import RatePricing from "@liveeps/components/atoms/rate-pricing"

export default {
  name: 'rate-amount',

  components: {
    'rate-points': RatePoints,
    'rate-pricing': RatePricing
  },

  props: {
    prices: Object,
    rate_only: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
    }
  },

  computed: {

    // Estrae e normalizza solo i dati utili al template
    pricing() {
      const pricing = markupPricing(this.prices),
            points = get_to_points(pricing.live_price)

      return {
        live_price: pricing.live_price,
        before_price: pricing.strikeThrough || pricing.markedUpTotalBeforeDiscount,
        ...(points && { points: points.total })
      }
    },

    // Restituisce il costo in punti ed eventuale integrazione in valuta
    amount_points() {
      if (!this.pricing.points) return false
      return compute_amount_points(this.pricing.live_price, this.get_availability())
    },
  },

  watch: {
    // appena amount_points cambia, emetti l'evento
    amount_points: {
      handler(newVal) {
        this.$emit("update:amount_points", newVal)
      },
      immediate: true
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>
</style>